import React, { memo, useState } from "react"

import { ModuleHeader, useAppContext, WorkIconEmpty, StarEmpty } from "@dit/core-frontend"
import { Stack } from "@mos-cat/ds"
import { ZoneCreateTarget } from "@components/zones"
import { CreatePageModal } from "@components/pages/CreatePageModal"
import { checkPermission } from "../store/permissionModel"
import { PAGE_TITLE } from "@pages/RecentWork/RecentWorkUtils"
import { ROUTES } from "@src/constants"

const MODAL_OPTIONS = {
  CREATE_ZONE: "create-zone",
  CREATE_PAGE: "create-page",
}

export const Header = memo(() => {
  const { isMoshub } = useAppContext()
  const [showModal, setShowModal] = useState(null)

  const handleSetModal = (value) => {
    setShowModal(value)
  }

  const onSearch = (val) => {
    if (val) {
      window.location.href = `${ROUTES.PAGES_LIST}?search=${val}`
    }
  }
  return (
    <>
      <ModuleHeader
        sseTopics={[]}
        leftItems={[
          {
            type: "popover",
            title: "Разделы",
            isVisible: checkPermission("ZONE_LIST_READ"),
            content: [
              { type: "link", title: "Все разделы", to: ROUTES.ZONES_LIST },
              {
                type: "action",
                title: "Создать",
                isVisible: checkPermission("ZONE_CREATE") && !isMoshub,
                onClick: () => handleSetModal(MODAL_OPTIONS.CREATE_ZONE),
              },
            ],
          },
          {
            type: "popover",
            title: "Страницы",
            isVisible: checkPermission("ZONE_LIST_READ"),
            content: [
              { type: "link", title: "Все страницы", to: ROUTES.PAGES_LIST },
              {
                type: "action",
                title: "Создать",
                onClick: () => handleSetModal(MODAL_OPTIONS.CREATE_PAGE),
              },
            ],
          },
        ]}
        iconItems={[
          {
            type: "popover",
            title: "История работы",
            Icon: WorkIconEmpty,
            content: [
              { type: "link", title: PAGE_TITLE.EDIT, to: ROUTES.RESENT_WORK },
              { type: "link", title: PAGE_TITLE.VIEW, to: ROUTES.VIEW_HISTORY },
            ],
          },
          {
            type: "link",
            title: "Избранное",
            Icon: StarEmpty,
            to: ROUTES.FAVORITES,
          },
        ]}
        centerItems={[
          {
            type: "action",
            title: "Создать",
            onClick: () => handleSetModal(MODAL_OPTIONS.CREATE_PAGE),
          },
        ]}
        onSearch={onSearch}
      />

      <ZoneCreateTarget
        modalDisclosureProps={{
          as: Stack,
          space: "10px",
          position: "relative",
        }}
        modalStateProps={{
          visible: showModal === MODAL_OPTIONS.CREATE_ZONE,
          hide: () => handleSetModal(null),
        }}
      />
      <CreatePageModal
        modalDisclosureProps={{
          as: Stack,
          space: "10px",
          position: "relative",
        }}
        modalStateProps={{
          visible: showModal === MODAL_OPTIONS.CREATE_PAGE,
          hide: () => handleSetModal(null),
        }}
      />
    </>
  )
})

Header.displayName = "Header"
